import { AsyncPipe } from '@angular/common';
import { Component, Input, output, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BbitUtils, IBbitWebShopItemStockResponse } from '@bbitgmbh/bbit.utils';
import { I18nPipe } from '@bbitgmbh/website.sdk';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-quantity-input',
  templateUrl: './quantity-input.component.html',
  styleUrls: ['./quantity-input.component.scss'],
  imports: [ReactiveFormsModule, FormsModule, AsyncPipe, I18nPipe],
})
export class QuantityInputComponent {
  public showSelect = signal(true);
  public value = new BehaviorSubject(1);
  public id = `quantity-select-${BbitUtils.makeId({ leadingHashtag: false })}`;
  public asLongAsSupplyLasts = signal(false);
  public availableQuantity = signal(0);
  private _defaultSelectOptions = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5+' },
  ];
  public selectOptions = signal<{ value: number; label: string }[]>(this._defaultSelectOptions);

  @Input()
  set stock(value: IBbitWebShopItemStockResponse | undefined) {
    this.asLongAsSupplyLasts.set(value?.asLongAsSupplyLasts || false);
    if (value?.asLongAsSupplyLasts) {
      this.selectOptions.set(this._defaultSelectOptions.filter((opt) => opt.value <= value.available));
      this.availableQuantity.set(value.available);
    } else {
      this.selectOptions.set(this._defaultSelectOptions);
      this.availableQuantity.set(999);
    }
  }

  @Input()
  set quantity(value: number | null) {
    if (value) {
      if (value >= this._defaultSelectOptions.length) {
        this.showSelect.set(false);
      }
    }
    this.value.next(value || 1);
  }
  get quantity(): number {
    return this.value.value;
  }

  readonly quantityChange = output<number>();

  changeValue(value: number) {
    if (value >= this._defaultSelectOptions.length) {
      this.showSelect.set(false);
    }
    this.value.next(value);
    this.quantityChange.emit(value);
  }

  onBlur(): void {
    const newValue = this.value.value;
    if (newValue !== this.value.value) {
      this.value.next(newValue);
      this.quantityChange.emit(newValue);
    }
  }
}
